module.exports = __webpack_public_path__ + "static/media/email_phone.b5959126.svg";